import React from 'react';

export default function ResultsBlock3Main() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-surface border-b border-line">
      <div className="max-w-[1024px] mx-auto flex flex-col gap-32">

        {/* PILOTO 1 */}
        <div className="flex flex-col text-left">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-6">
            Piloto 1 · Antes del diagnóstico
          </div>
          <h2 className="text-[28px] md:text-[40px] font-bold text-ink mb-12 tracking-tight">
            Focalización de recursos en Examen Preventivo
          </h2>

          <div className="flex flex-col md:flex-row gap-16 lg:gap-24 items-start">
            <div className="w-full md:w-1/2">
              <p className="text-[18px] text-ink-soft leading-[1.6] mb-8">
                El objetivo fue evaluar si contactar proactivamente a un grupo de riesgo producía un mayor rendimiento diagnóstico (hallazgo de sospechas de HTA, DM2, o Riesgo CV) comparado con la demanda espontánea que llega directamente al CESFAM.
              </p>
              <div className="text-[16px] font-semibold text-brand tracking-widest uppercase mb-4">
                Reducción de esfuerzo estéril
              </div>
              <p className="text-[16px] text-ink-soft leading-[1.6]">
                El grupo priorizado requirió significativamente menos evaluaciones para llegar a un hallazgo de riesgo de enfermedad cardiometabólica.
              </p>
            </div>
            
            <div className="w-full md:w-1/2 flex flex-col gap-10 border-l-2 border-line pl-8">
              <div className="flex flex-col gap-2">
                <div className="text-[64px] font-bold text-ink-soft/30 leading-none">9,2</div>
                <div className="text-[14px] font-semibold text-ink-soft/70 uppercase">EMPA por hallazgo (Demanda espontánea)</div>
              </div>
              
              <div className="flex flex-col gap-2">
                <div className="text-[64px] font-bold text-brand leading-none">3,6</div>
                <div className="text-[14px] font-semibold text-ink uppercase">EMPA por hallazgo (Grupo priorizado)</div>
              </div>
              
              <div className="mt-4 text-[16px] font-bold text-ink bg-paper px-4 py-3 rounded-xl inline-block w-max">
                61% menos EMPA por hallazgo
              </div>
            </div>
          </div>
        </div>

        {/* PILOTO 2 */}
        <div className="flex flex-col text-left">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-6">
            Piloto 2 · En enfermedad conocida
          </div>
          <h2 className="text-[28px] md:text-[40px] font-bold text-ink mb-12 tracking-tight">
            Gestión anticipatoria en personas con DM2
          </h2>

          <div className="flex flex-col md:flex-row gap-16 lg:gap-24 items-start">
            <div className="w-full md:w-1/2">
              <p className="text-[18px] text-ink-soft leading-[1.6] mb-8">
                Dentro de una población de 1.108 personas con DM2 que ya estaban bajo control del programa PSCV, se aplicó una priorización operacional para identificar quiénes requerían evaluación inmediata. Estar bajo control no significa que todos los hitos estén resueltos.
              </p>
              <div className="text-[16px] font-semibold text-brand tracking-widest uppercase mb-4">
                Nueva evidencia y reclasificación
              </div>
              <p className="text-[16px] text-ink-soft leading-[1.6]">
                La intervención dirigida no solo confirmó hitos pendientes, sino que generó nueva evidencia que derivó en la reclasificación de riesgo de los pacientes.
              </p>
            </div>
            
            <div className="w-full md:w-1/2 flex flex-col gap-10 border-l-2 border-line pl-8">
              <div className="flex flex-col gap-2">
                <div className="text-[64px] font-bold text-ink-soft/30 leading-none">1.108</div>
                <div className="text-[14px] font-semibold text-ink-soft/70 uppercase">Personas bajo control PSCV</div>
              </div>
              
              <div className="flex flex-col gap-2">
                <div className="text-[64px] font-bold text-brand leading-none">416</div>
                <div className="text-[14px] font-semibold text-ink uppercase">Priorizadas para evaluación</div>
              </div>

              <div className="flex flex-col gap-2">
                <div className="text-[64px] font-bold text-ink leading-none">22,2%</div>
                <div className="text-[14px] font-semibold text-ink-soft/70 uppercase">Con hallazgo alterado (ITB)</div>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSURE: LEARNING */}
        <div className="flex flex-col items-start bg-[#ccccff] text-ink rounded-lg p-10 md:p-16 text-left shadow-sm mt-8 border border-brand/20">
          <div className="text-[14px] font-semibold text-ink-soft tracking-widest uppercase mb-6">
            Un mismo aprendizaje
          </div>
          <h3 className="text-[32px] md:text-[40px] font-bold mb-8 max-w-2xl leading-[1.2]">
            Encontrar a la persona correcta es sólo el comienzo.
          </h3>
          <p className="text-[18px] text-ink-soft leading-[1.6] max-w-3xl">
            Los dos pilotos abordaron momentos distintos del continuo cardiometabólico. En ambos apareció la misma necesidad operacional: identificar el riesgo es inútil si la persona se pierde en la red antes de recibir la siguiente atención. BAC generaliza este aprendizaje para transformar evidencia en trabajo ejecutable, coordinando qué ocurre después.
          </p>
        </div>

      </div>
    </section>
  );
}
